/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Packaging_HintInputs */

const vi_sales_return_packaging_hint = /** @type {(inputs: Sales_Return_Packaging_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick vật tư bao bì khách trả kèm để nhập lại kho.`)
};

/**

* @param {Sales_Return_Packaging_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_packaging_hint = /** @type {((inputs?: Sales_Return_Packaging_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Packaging_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_packaging_hint(inputs)
});